/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { set, uniq } from 'lodash-es';

import {
  getOrdersFromCompanyId,
  removeSubscriptionsFromOrder,
} from '@/services/api/buy/order';

// initial state
const state = {
  orders: [],
  ownedProducts: [],
};

const calcContracts = (orders) => orders
  .filter((order) => order.subscriptions)
  .map((order) => order.subscriptions
    .filter((subscription) => subscription.status === 'ACTIVE'
      || subscription.status === 'EXPIRED'
      || subscription.status === 'SUSPENDED'
      || subscription.status === 'CANCELLED'
      || subscription.status === 'IN_PROGRESS'))
  .reduce((a, b) => a.concat(b), []);

const calcOwnedProduct = (orders) => uniq(calcContracts(orders)
  .map((subscription) => subscription.grid.id));

// getters
const getters = {
  get: (state) => state.orders,
  ownedProducts: (state) => state.ownedProducts,
};

// actions
const actions = {
  async setOrders({ dispatch, rootGetters }) {
    const { companyId } = rootGetters['company/get'];
    try {
      const success = await getOrdersFromCompanyId(companyId);
      await dispatch('setValue', { orders: success.data });
      await dispatch('setValue', { ownedProducts: calcOwnedProduct(success.data) });
      return dispatch('contracts/setSubscriptions',
        { subscriptions: calcContracts(success.data) },
        { root: true });
    } catch (err) {
      dispatch('reporting/sendError', { err, currentPage: 'Orders' }, { root: true });
      throw (err);
    }
  },
  async remove({ dispatch }, subscription) {
    try {
      await removeSubscriptionsFromOrder(subscription.orderId, subscription.id);
    } catch (err) {
      dispatch('reporting/sendError', { err, currentPage: 'Pricing' }, { root: true });
    }
  },
  setValue({ commit }, object) {
    commit('SET_VALUE', object);
  },
  setValueWithPath({ commit }, object) {
    commit('SET_VALUE_WITH_PATH', object);
  },
  clear({ commit }) {
    commit('CLEAR');
  },
};

// mutations
const mutations = {
  CLEAR(state) {
    Object.assign(state, {
      orders: [],
      ownedProducts: [],
    });
  },
  SET_VALUE(state, object) {
    const [key] = Object.keys(object);
    state[key] = object[key];
  },
  SET_VALUE_WITH_PATH(state, { value, path }) {
    set(state, path, value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
